import { Model, Variant } from "@store/mmvData/types";

export interface MmvListEntry {
  key: string;
  displayName: string;
  variant: Variant;
}

export function getBikeVariantDisplayName(
  vehicleName: string,
  variant: Pick<Variant, "cc" | "fuelType">,
  isNewBike?: boolean
) {
  const name = vehicleName.trim();

  if (isNewBike) {
    return name;
  }

  const powerText =
    variant.fuelType === "electric"
      ? `${(variant.cc / 1000).toFixed(1)} kW`
      : `${variant.cc}CC`;

  return `${name} ${powerText}`.trim();
}

export function getDefaultVariant(variants: Variant[] = []): Variant | null {
  if (!variants.length) {
    return null;
  }

  return variants.find(variant => variant.popular) ?? variants[0];
}

export function getMmvListEntries(
  options: Model[],
  isNewBike?: boolean
): MmvListEntry[] {
  const entries: MmvListEntry[] = [];

  options.forEach(option => {
    if (isNewBike) {
      const variant = getDefaultVariant(option.variants);
      if (!variant) {
        return;
      }

      const displayName = getBikeVariantDisplayName(option.name, variant, true);

      entries.push({
        key: option.id,
        displayName,
        variant: {
          ...variant,
          verbose: displayName,
          image: option.image
        }
      });
      return;
    }

    (option.variants ?? []).forEach(variant => {
      const displayName = getBikeVariantDisplayName(option.name, variant, false);

      entries.push({
        key: variant.id,
        displayName,
        variant: {
          ...variant,
          verbose: displayName,
          image: option.image
        }
      });
    });
  });

  return entries;
}
